/* unplugin-vue-components disabled */import { render } from "./Layout2.vue.js?vue&type=template&id=6c32a95d!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Layout2.vue?vue&type=template&id=6c32a95d"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__